import { memo } from 'react';
import { useTradingSummaryHashState } from '~/modules/tradeSheet/tradingAnalyzer/useTradingSummaryHashState';
import { totalProfitCss } from '~/modules/tradeSheet/tradingAnalyzer/tradingAnalyzerCss';
const NetProfit = memo(function TotalProfit() {
    const { state } = useTradingSummaryHashState.useContainer();
    return <div css={totalProfitCss}>{state.netProfit}</div>;
});
export default NetProfit;
